module.exports = "/_next/static/resources/girls-inc-wide-995e9223dd09068996a81660d7950c0b.png";